// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__UDDYf","loader":"Loader_loader__+lRPl","dot":"Loader_dot__7Nm3P","pulse":"Loader_pulse__P63UF","text":"Loader_text__xMshV"};